import styled from 'styled-components';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	${minWidth('mobileLarge')} {
		margin: 0 24px;
	}
`;

export const SectionWrapper = styled.section`
	min-height: 462px;
	margin-bottom: 10px;

	${minWidth('mobileLarge')} {
		min-height: 480px;
		margin: 0 auto 40px;
	}

	${minWidth('desktop')} {
		min-height: 680px;
		margin: 0 auto 60px;
		max-width: 1400px;
	}
`;

export const SectionContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	max-width: 440px;

	${minWidth('mobileLarge')} {
		max-width: 870px;
	}

	${minWidth('desktop')} {
		align-items: flex-start;
		max-width: 1040px;
	}
`;

export const SectionHeading = styled.h2`
	${fontWeight(FontWeights.Light)};
`;

export const SectionCopy = styled.p`
	${fontWeight(FontWeights.Light)};
`;
